

import { 
  Bar,
  mixins
} from 'vue-chartjs'
const {
  reactiveProp
} = mixins

export default {
  extends: Bar,
  mixins: [ reactiveProp ],
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  data:() => ({
   options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: true
            }
          }]
        },
        legend: {
          display: false
        },
        maintainAspectRatio: false
      }
  }),
  mounted () {
    // this.chartData is created in the mixin and contains all the data needed to build the chart.
    this.renderChart(this.chartData, this.options)
  }
};
